export default __webpack_public_path__ + "static/media/S_draw.47fea975.PNG";